import React from 'react';
import { Select, Button, Modal, ToastContext } from '@weezevent/nacre';
import { useTranslation } from 'react-i18next';
import { fetcher } from '@weezevent/weezjs-core';

const FormModal = ({ editFormModal, setEditFormModal, forms, ticket_office, eventId, organization, syncTicketOffice, ticketOfficeRate }) => {
    const { t } = useTranslation();
    const [stateSelect, setStateSelect] = React.useState(ticketOfficeRate.id_form || 0);
    const toast = React.useContext(ToastContext);
    const onSubmit = React.useCallback(() => {
        let data = {
            id_form: stateSelect
        };
        let promise = null;
        if (ticketOfficeRate.ticket_office_rate_id == null) {
            data = { ...data, active: 1, rate_id: ticketOfficeRate.id };
            promise = fetcher.post(`/ticket/organizations/${organization.id}/ticket_office/${ticket_office.id}/event/${eventId}/rate`, { data });
        } else {
            promise = fetcher.patch(`/ticket/organizations/${organization.id}/ticket_office/${ticket_office.id}/event/${eventId}/rate/${ticketOfficeRate.ticket_office_rate_id}`, {
                data
            });
        }
        promise
            .then(() => {
                syncTicketOffice({
                    allow_cache: false,
                    cache: false
                });
                toast.success(t('ticket.ticket_office_rates.send_forms.sucess'));
            })
            .catch(() => toast.error(t('ticket.ticket_office_rates.send_forms.error')))
            .finally(() => {
                setEditFormModal(false);
            });
        return;
    }, [stateSelect, organization, ticket_office, eventId, ticketOfficeRate, syncTicketOffice]);

    let options = React.useMemo(() => {
        return forms.map((form, index) => {
            return { text: form.name, value: form.weez_id };
        });
    }, [forms]);

    let _options = React.useMemo(
        () => [...options, { text: t('ticket.ticket_office_rates.default_form'), value: 0 }, { text: t('ticket.ticket_office_rates.no_form'), value: -1 }],
        [options]
    );

    return (
        <Modal
            size={'medium'}
            open={editFormModal}
            allowExternalClosing
            onClose={() => setEditFormModal(false)}
            title={t('ticket.ticket_office_rates.modify_rates')}
            submitButton={<Button primary onClick={onSubmit} label={t('ticket.common.action.save')} />}
            cancelButton={<Button onClick={() => setEditFormModal(false)} label={t('ticket.common.action.back')} />}
        >
            <Select
                search
                useNew
                onChange={value => {
                    setStateSelect(value);
                }}
                options={_options}
                value={stateSelect}
                placeholder={t('ticket.ticket_office_rates.choose_form')}
            />
        </Modal>
    );
};

export default FormModal;
